import { useInfiniteQuery } from '@tanstack/react-query';

import ProductsService, {
  ProductsQueryFilterDto,
} from '@/services/ProductsService';

export const GET_PRODUCTS_QUERY_KEY = (
  queryFilterDto?: Partial<ProductsQueryFilterDto>,
) => ['products', { ...queryFilterDto }];

export function useGetProducts(
  queryFilterDto?: Partial<ProductsQueryFilterDto>,
) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: GET_PRODUCTS_QUERY_KEY(queryFilterDto),
      initialPageParam: 1,
      queryFn: ({ pageParam }) =>
        ProductsService.getProducts({
          ...queryFilterDto,
          page: pageParam,
          limit: queryFilterDto?.limit ?? 12,
        }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const data = lastPage;

        if (data.currentPage === data.totalPages || data.totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const products = data?.pages.flatMap((page) => page?.items);

  return {
    products: products ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
